import { Field, LinkField, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import Link from 'components/helpers/Link/Link';
import classNames from 'classnames/bind';
import styles from './BlogLinkListing.module.scss';
import CaratIcon from 'public/static-assets/svg-icons/carat.svg';
import withStyles from 'lib/enhancers/withStyles';
import compose from 'lib/enhancers/compose';
import withValidDatasourceCheck from 'lib/enhancers/withValidDatasourceCheck';

const cx = classNames.bind(styles);

type BlogLinkListingProps = ComponentProps & {
  fields: {
    title: Field<string>;
    blogItems: BlogItem[];
    link: LinkField;
    linkText: Field<string>;
  };
};

type BlogItem = {
  title: string;
  link: string;
};

const BlogLinkListing = (props: BlogLinkListingProps): React.JSX.Element => {
  const { className, fields } = props;
  const { sitecoreContext } = useSitecoreContext();

  return (
    <div className={cx('blog-link-listing', 'component-container-edge', className)}>
      <div className={cx('blog-link-listing-heading')}>
        <h3>
          <Text field={fields.title} encode={sitecoreContext.pageEditing} />
        </h3>
      </div>
      <div className={cx('blog-link-listing-container')}>
        {fields.blogItems?.map((item, i) => (
          <div className={cx('blog-link-listing__link')} key={i}>
            <Link
              field={{ value: { href: item.link, target: '_blank' } }}
              showLinkTextWithChildrenPresent={false}
              editable={false}
            >
              <Text field={{ value: item.title }} editable={false} />
              <CaratIcon className={cx('blog-link-listing__carat')} />
            </Link>
          </div>
        ))}
      </div>
      <div className={cx('blog-link-listing-bottom')}>
        {fields.link?.value.href !== '' && (
          <Link field={fields.link} showLinkTextWithChildrenPresent={false} icon="carat">
            <Text field={fields.linkText} encode={sitecoreContext.pageEditing} />
          </Link>
        )}
      </div>
    </div>
  );
};

export default compose<BlogLinkListingProps>(withValidDatasourceCheck(), withStyles())(BlogLinkListing);
